//import * as GBCXPromo from 'GBCXPromo';
import { game } from '../main';
import { GameGrid } from '../Elements/GameGrid';
import { EffectsLayer } from '../Elements/EffectsLayer';
import { Shooter } from '../Elements/Shooter';
import { GameUI } from '../Elements/GameUI';
import { WindowLayer } from '../Elements/WindowLayer';
import { PopupGameOver } from '../Elements/PopupGameOver';
import { getGameConfig } from '../utils/getGameConfig';
import {FlyingBubblesGroup} from "js/Elements/FlyingBubblesGroup";
import {ShooterFlyingBubble} from "js/Elements/ShooterFlyingBubble";
import {PointerLayer} from "js/Elements/PointerLayer";
// import { XPromoBanners } from '../Elements/XPromoBanners';

declare const GBCXPromo;

export class GameState extends Phaser.State {
  public static key = 'GameState';
  public backgroundImage: Phaser.Image;
  private grid: GameGrid;
  private fxLayer: EffectsLayer;
  private shooter: Shooter;
  private flyingBubblesGroup: FlyingBubblesGroup;
  private pointerLayer: PointerLayer;
  private ui: GameUI;
  private windowLayer: WindowLayer;

  public create() {
    this.setupBackground();

    GBCXPromo.gameStart();

    game.config.gameOver = false;

    const config = getGameConfig();

    this.grid = new GameGrid(config.grid);

    this.grid.signals.onFxRemoveBubblesRequest.add((bubbles) => this.fxLayer.initBubbles(bubbles));

    this.pointerLayer = new PointerLayer();

    this.fxLayer = new EffectsLayer();
    this.fxLayer.position.setTo(this.grid.x, this.grid.y);
    this.fxLayer.signals.onAddPoints.add((amount) => {
      this.ui.increaseScore(amount);
    });

    this.shooter = new Shooter(this.grid, config.shooter, () => {
      return game.config.gameOver || !this.ui.isBlockingShooter() || !this.windowLayer.isEmpty();
    });
    this.flyingBubblesGroup = new FlyingBubblesGroup(this.grid);
    this.pointerLayer.setDependencies(this.grid, this.shooter, this.flyingBubblesGroup);
    this.shooter.onShoot.add((bubble: ShooterFlyingBubble) => {
      this.flyingBubblesGroup.addShooterBubble(bubble);
      this.pointerLayer.invalidate();
    });
    this.grid.signals.onGameOver.add((won: boolean) => {
      game.config.gameOver = true;
      this.handleGameOver(won);
    });
    this.grid.signals.onMoveDone.add((success) => this.shooter.onMoveDone(success));

    this.windowLayer = new WindowLayer();

    this.ui = new GameUI(this.windowLayer, this.grid, () => this.shooter.changeCurrentToBomb());

    // @ts-ignore
    this.windowLayer.parent.moveUp(this.windowLayer);

    game.time.events.add(1, () => {
      game.resizeGame();
      // new XPromoBanners();
    });
  }

  private setupBackground(): void {
    if (game.config.skinId > 0) {
      this.backgroundImage = game.add.sprite(0, 0, game.config.skinId + '_bg');
      this.backgroundImage.anchor.x = 0.5;
      this.backgroundImage.anchor.y = 0.5;
      this.backgroundImage.x = this.game.canvas.width / 2;
      this.backgroundImage.y = this.game.canvas.height / 2;
      if (this.backgroundImage.height < this.game.canvas.height) {
        const ratio = this.game.canvas.height / this.backgroundImage.height;
        this.backgroundImage.scale.set(ratio, ratio);
      }
    }
  }

  private handleGameOver(won: boolean): void {
    const score = this.ui.getScore();
    const bonusScore = won ? this.ui.getScore() : 0;
    const total = score + bonusScore;

    //@ts-ignore
    /*GBCXPromo.displayResultScreen(total, async () => {
      game.paused = true;
      //@ts-ignore
      await GBCXPromo.ads.showInterstitalAd(true);
      game.paused = false;
      game.state.start(GameState.key);
    });*/


    game.time.events.add(1000, () => {
      GBCXPromo.gameOver(null, total);
      this.windowLayer.pushWindow(() => {
        return new PopupGameOver({
          won,
          score,
          bonusScore,
          bubblesPopped: this.grid.bubblesPopped,
        });
      });
    });

  }
}
